export default __webpack_public_path__ + "static/media/screen_facebook_6.80cdec11.png";